var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentListHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: 222,
    viewBox: "0 0 1118 222",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_98219)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159.004,
    cy: -80.9963,
    r: 364,
    transform: "rotate(-19.8583 159.004 -80.9963)",
    fill: "url(#paint0_linear_457_98219)",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_457_98219)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1082.22,
    cy: 183.223,
    r: 200.348,
    transform: "rotate(175.258 1082.22 183.223)",
    fill: "url(#paint1_linear_457_98219)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_457_98219",
    x1: 108.057,
    y1: -36.7532,
    x2: 222.687,
    y2: 237.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF4FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_457_98219",
    x1: 1054.18,
    y1: 207.575,
    x2: 1117.27,
    y2: 358.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBDFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF4FB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_98219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 304,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_457_98219"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 866,
    width: "100%",
    height: 304,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentListHeader);
export default __webpack_public_path__ + "static/media/documentListHeader.4f2d966e2b6afd25428f2ffc6b157c6d.svg";
export { ForwardRef as ReactComponent };